<template>
  <v-card class="py-1">
    <div>
      <div class="d-flex align-center justify-space-between pt-2 mb-3">
        <div class="titre-h3 align-self-center secondary--text pl-3">
          Envie de souscrire ?
        </div>
        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon class="texte-gris-fonce">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div
        class="d-flex justify-center flex-column titre-h4 secondary--text pb-4 px-3"
      >
        <ContactConseiller code-feature="DETAILS_ABONNEMENT" />
      </div>
      <div
        v-if="hasDemandeRecente"
        class="d-flex justify-center intro secondary--text py-3"
      >
        <v-icon
          class="px-3"
          color="secondary"
        >
          mdi-check
        </v-icon>
        <div class="align-self-center">
          Un email a bien été envoyé
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'
import ContactConseiller from '@/components/contact-conseiller.vue'

export default {
  name: 'DemandeAbonnementModal',
  components: {ContactConseiller},

  computed: {
    ...mapGetters({
      hasDemandeRecente: 'demandeInfosAbonnement/hasDemandeRecente',
    }),
  },

  methods: {
    onClose () {
      this.$emit('close')
    },
  }
}
</script>
